var DB = null;
const openDB = function(fun=function(){}){
	if(DB){
		fun(DB)
		return
	}
	let newDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
	if(!newDB){
		fun(null,"浏览器不支持indexedDB")
		return
	}
	let request = newDB.open("dcedu", 1);
	request.onerror = (e)=>{
		fun(null,"打开DB失败",e)
	}
	request.onupgradeneeded = function(event){
		DB = event.target.result;
		DB.createObjectStore("test", { keyPath : "name" });
	};
	request.onsuccess = (e)=>{
		DB = e.target.result;
		fun(DB)
	}
};
export default {
	insert(obj,fun=function(){}){
		openDB((db,err)=>{
			if(!db){
				fun(false,err)
				return
			}
			try{
				let transaction = db.transaction(['test'],"readwrite");
				let objectStore = transaction.objectStore("test");
				objectStore.add(obj);
				fun(true)
			}catch(err){
				fun(false,err)
			}
			
		})
	},
	select(name,fun=function(){}){
		openDB((db,err)=>{
			if(!db){
				fun(false,null,err)
				return
			}
			if(typeof name !== "string"){
				fun(false,null,"name is not string")
			}
			let transaction = db.transaction(["test"],"readwrite").objectStore("test");
			let request = transaction.get(name)
			request.onsuccess = function(){
				if(request.result){
					fun(true,request.result)
					return
				}
				fun(false,null,"no data")
			}
		})
	}
}